var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-graph-table-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-graph-table-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-graph-table-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "wkb-graph-table-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
              _vm._m(0),
              _c("div", { staticClass: "wkb-graph-table-body" }, [
                _c("div", { staticClass: "wkb-graph-table-ledger" }, [
                  _c("div", { staticClass: "wkb-graph-table-toolbar" }, [
                    _c(
                      "div",
                      {
                        staticClass: "wkb-graph-table-tabs",
                        attrs: {
                          role: "tablist",
                          "aria-label": "Graph node type",
                        },
                      },
                      _vm._l(_vm.visibleTabs, function (tab) {
                        return _c(
                          "button",
                          {
                            key: tab.key,
                            staticClass: "wkb-graph-table-tab",
                            class: { "is-active": _vm.activeTab === tab.key },
                            attrs: {
                              id: _vm.tabButtonId(tab.key),
                              type: "button",
                              role: "tab",
                              "aria-selected":
                                _vm.activeTab === tab.key ? "true" : "false",
                              "aria-controls": _vm.panelId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setActiveTab(tab.key)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(tab.label) + " ")]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "wkb-graph-table-csv-action" }, [
                      _c(
                        "button",
                        {
                          staticClass: "wkb-graph-table-csv-btn",
                          attrs: {
                            type: "button",
                            disabled: !_vm.activeRows.length,
                          },
                          on: { click: _vm.downloadCurrentTab },
                        },
                        [_vm._v(" Download CSV ")]
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "wkb-graph-table-panel",
                      attrs: {
                        id: _vm.panelId,
                        role: "tabpanel",
                        "aria-labelledby": _vm.tabButtonId(_vm.activeTab),
                      },
                    },
                    [
                      _vm.activeRows.length
                        ? _c("div", { staticClass: "wkb-graph-table-wrap" }, [
                            _c("table", { staticClass: "wkb-graph-table" }, [
                              _vm._m(1),
                              _c(
                                "tbody",
                                _vm._l(_vm.pagedRows, function (row) {
                                  return _c(
                                    "tr",
                                    {
                                      key: row.node_id,
                                      class: {
                                        "is-key-node-row": row.is_key_node,
                                      },
                                    },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "wkb-graph-table-label",
                                        },
                                        [_vm._v(_vm._s(row.label))]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatValue(row.aggregate_score)
                                          )
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatValue(row.raw_max_score)
                                          )
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatValue(row.raw_mean_score)
                                          )
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(row.novelty_label || "NYA")
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(row.relevance_label || "NYA")
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "wkb-graph-table-col-description",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(row.rationale || "NYA") +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("td", [_vm._v(_vm._s(row.shown))]),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "wkb-graph-table-col-action",
                                        },
                                        [
                                          row.shown === "yes"
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "wkb-graph-table-remove-btn",
                                                  attrs: {
                                                    type: "button",
                                                    disabled: _vm.graphBusy,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onRemoveRow(
                                                        row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Remove ")]
                                              )
                                            : _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "wkb-graph-table-add-btn",
                                                  attrs: {
                                                    type: "button",
                                                    disabled:
                                                      _vm.graphBusy ||
                                                      _vm.addingNodeId ===
                                                        row.node_id,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onAddRow(row)
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.addingNodeId ===
                                                          row.node_id
                                                          ? "Adding…"
                                                          : "Add"
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ])
                        : _c("p", { staticClass: "wkb-graph-table-empty" }, [
                            _vm._v(
                              " No " +
                                _vm._s(_vm.activeTabLabel.toLowerCase()) +
                                " on the graph yet. "
                            ),
                          ]),
                      _c("WorkspaceGraphTablePagination", {
                        attrs: {
                          "current-page": _vm.currentPage,
                          "total-pages": _vm.totalPages,
                        },
                        on: {
                          "page-change": function ($event) {
                            _vm.currentPage = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "wkb-graph-table-head" }, [
      _c("h2", { attrs: { id: "wkb-graph-table-title" } }, [
        _vm._v("Graph data"),
      ]),
      _c("p", [
        _vm._v(
          " Retrieved nodes from graph build and expansion, including options not yet on the canvas. "
        ),
      ]),
      _c(
        "p",
        {
          staticClass: "wkb-graph-table-legend",
          attrs: { "aria-label": "Selected node rows legend" },
        },
        [
          _c("span", { staticClass: "wkb-graph-table-legend-item" }, [
            _c("span", {
              staticClass: "wkb-graph-table-legend-swatch",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Selected node "),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "wkb-graph-table-col-name" }, [_vm._v("Name")]),
        _c("th", [_vm._v("Aggregate")]),
        _c("th", [_vm._v("Max")]),
        _c("th", [_vm._v("Mean")]),
        _c("th", [_vm._v("Novelty")]),
        _c("th", [_vm._v("Relevance")]),
        _c("th", { staticClass: "wkb-graph-table-col-description" }, [
          _vm._v("Description"),
        ]),
        _c("th", [_vm._v("Shown")]),
        _c("th", { staticClass: "wkb-graph-table-col-action" }, [
          _vm._v("Action"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }